import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLangPath } from "@/hooks/use-lang-path";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const lp = useLangPath();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">{t("notFound.title")}</h1>
        <p className="mb-4 text-xl text-muted-foreground">{t("notFound.message")}</p>
        <a href={lp("/")} className="text-primary underline hover:text-primary/90">{t("notFound.link")}</a>
      </div>
    </div>
  );
};

export default NotFound;
